/**
 * Compact relative timestamp for notification rows: "just now", "5m ago",
 * "3h ago", "2d ago", then falls back to an absolute "12 Jun" date.
 */
export function formatRelativeTime(value: Date | null): string {
  if (!value) return '';

  const diffMs = Date.now() - value.getTime();
  const sec = Math.round(diffMs / 1000);
  if (sec < 45) return 'just now';

  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;

  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;

  const day = Math.round(hr / 24);
  if (day < 7) return `${day}d ago`;

  return value.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
}
